import React from 'react';
import {
  Route,
  Switch,
  useHistory,
  useLocation,
  useRouteMatch,
} from 'react-router';
import Button from '../ui/form/Button';
import Page, { PageTitle } from '../ui/Page';
import List from '../engine/List';
import Create from '../engine/Create';
import Engine from '../engine/Engine';

export default function Engines() {
  const match = useRouteMatch();
  const location = useLocation();
  const history = useHistory();

  return (
    <Page title={'Engines'}>
      <PageTitle>
        {location.pathname === '/engines' && (
          <Button
            label="New Engine +"
            onClick={() => {
              history.push('/engines/create');
            }}
          />
        )}
      </PageTitle>
      <Switch>
        <Route path={`${match.path}/create`}>
          <Create />
        </Route>
        <Route path={`${match.path}/:engineid`}>
          <Engine />
        </Route>
        <Route path={match.path}>
          <List />
        </Route>
      </Switch>
    </Page>
  );
}
